export default __webpack_public_path__ + "03663f725bd29df9316a336542c6f148.png";